import { cn } from '#app/shared/lib/misc.tsx'
import { Spacer } from '#app/shared/ui/data-display/Spacer.js'
import { Icon } from '#app/shared/ui/icons/Icon.js'

const certifications = [
  'Kilometraje verificado',
  'Ningún accidente previo ',
  'Ninguna avería previa significativa',
  'Revisión mecánica completa',
  'Reacondicionamiento estético al detalle',
  '14 días o 1.000 Km para probarlo',
  'Hasta 3 años de garantía',
]

type Props = {
  className?: string
  isFinanced?: boolean
}

export default function VehicleCertificates({
  className,
  isFinanced = false,
}: Props) {
  const finalCertifications = [
    ...certifications,
    ...(isFinanced
      ? [
          'Coche de sustitución incluido',
          'Seguro de vida, invalidez y retirada de carnet',
        ]
      : []),
  ]

  return (
    <div className="bg-white">
      <div
        className={`
          flex min-h-[220px] w-full justify-between gap-[42px] border-y
          border-neutral-75

          xl:w-[428px]
        `}
      >
        <div
          className={cn(
            `
              max-w-[304px] px-4 pb-6 pt-6

              xl:pl-11
            `,
            className,
          )}
        >
          <p className="text-h5-bold text-neutral-900">Vehículo garantizado</p>

          <Spacer size="16px" />
          <div className="flex flex-col gap-3">
            {finalCertifications.map((certification) => (
              <div
                className={`flex h-2.5 items-center gap-1`}
                key={certification}
              >
                <Icon
                  name="basic/check"
                  size="12px"
                  className={`text-primary-500`}
                />
                <p
                  className={`
                    whitespace-nowrap text-subtitle1-medium text-neutral-900
                  `}
                >
                  {certification}
                </p>
              </div>
            ))}
          </div>
        </div>

        <div
          className={`
            flex min-h-[220px] w-[6px] items-center justify-center border-l
            border-neutral-75 bg-[#F8FDFD] bg-cover bg-right bg-no-repeat

            xl:w-[124px]
          `}
        >
          <img
            className={`
              hidden h-[82px] w-[72px]

              xl:inline-flex
            `}
            src="/img/condition-shield.svg"
            alt="shield"
          />
        </div>
      </div>
    </div>
  )
}
